import { Component, Input } from '@angular/core';
import { GenericMenu } from 'src/app/tools/abstract-classes/generic-menu';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/app/tools/services/config.service';


@Component({
  selector: 'assabil-services-menu',
  templateUrl: './assabil-services-menu.component.html',
  styleUrls: ['./assabil-services-menu.component.scss']
})

export class AssabilServicesMenuComponent extends GenericMenu {

  @Input() shrinkMode : boolean = false;

  // assetMenu = {
    // 'id'          : 'services',
    // 'title'       : 'Gestion des Frigos',
    // 'prefix'      : 'F',
    // 'blocs'  :  [
    //                   {
    //                     'id'         : 'services-mobile',
    //                     'title'      : 'Exécution - Mobile',
    //                     'icon'       :  'assets/images/icons/mobile-app.png',
    //                     'items'      : [
    //                                     {
    //                                         'id'        : 'services-mobile-assetOrder',
    //                                         'label'     : 'Réception Fournisseur',
    //                                         'icon'      : "assets/icons/invoice.png",
    //                                         'route'     : './services/asset-order-mobile'
    //                                     },
    //                                     {
    //                                         'id'        : 'services-mobile-assetInventory'  ,
    //                                         'label'     : 'Inventaire',
    //                                         'icon'      : 'assets/icons/invoice.png',
    //                                         'route'     : './services/asset-inventoty-widget-mobile'
    //                                     }, 
    //                                     {
    //                                         'id'        : 'services-mobile-assetTransferFromBranch'  ,
    //                                         'label'     : 'Réception Agence',
    //                                         'icon'      : 'assets/icons/invoice.png',
    //                                         'route'     : './services/asset-transfer-from-branch-list-mobile'
    //                                     }, 
    //                                     {
    //                                         'id'        : 'services-mobile-assetTransferToBranch'  ,
    //                                         'label'     : 'Expédition Agence',
    //                                         'icon'      : 'assets/icons/invoice.png',
    //                                         'route'     : './services/asset-transfer-to-branch-list-mobile'
    //                                     }, 
    //                                     {
    //                                       'id'        : 'services-mobile-assetTransferToPartner'  ,
    //                                       'label'     : 'Expédition Client',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : './services/asset-shipment-list-mobile'
    //                                     }, 
    //                                     {
    //                                       'id'        : 'services-mobile-assetTransferFromPartner'  ,
    //                                       'label'     : 'Retour Client *',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : './services/asset-transfer-to-partner-list-mobile'
    //                                     },

    //                                     {
    //                                       'id'        : 'services-mobile-assetBarcode'  ,
    //                                       'label'     : 'Joindre le TAG',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : './services/asset-barcode-mobile'
    //                                     },
                        
    //                                   ]
    //                   },

    //                   {
    //                     'id'         : 'services-bo',
    //                     'title'      : 'Management',
    //                     'icon'       :  'assets/images/icons/web-app.png',
    //                     'items'      : [
    //                                       {
    //                                         'id'        : 'services-bo-assetDashboard'  ,
    //                                         'label'     : 'Tableau de bord',
    //                                         'icon'      : 'assets/icons/invoice.png',
    //                                         'route'     : './services/asset-dashboard'
    //                                     },
    //                                     {
    //                                         'id'        : 'services-bo-assetCall'  ,
    //                                         'label'     : 'Demandes de Frigos',
    //                                         'icon'      : 'assets/icons/invoice.png',
    //                                         'route'     : './services/asset-call-list'
    //                                     }, 
    //                                     {
    //                                         'id'        : 'services-bo-assetOrder'  ,
    //                                         'label'     : 'Bons de commande',
    //                                         'icon'      : 'assets/icons/invoice.png',
    //                                         'route'     : './services/asset-order'
    //                                     }, 
    //                                     {
    //                                         'id'        : 'services-bo-assets'  ,
    //                                         'label'     : 'Frigos',
    //                                         'icon'      : 'assets/icons/invoice.png',
    //                                         'route'     : './services/asset-list'
    //                                     }, 
    //                                     {  
    //                                         'id'        : 'services-bo-assetTransferToBranch' ,
    //                                         'label'     : 'Transferts Agence',
    //                                         'icon'      : 'assets/icons/invoice.png',
    //                                         'route'     : './services/asset-transfer-to-branch-list'
    //                                     }, 
    //                                     { 
    //                                         'id'        : 'services-bo-assetTransferToPartner' ,
    //                                         'label'     : 'Affectations Client',
    //                                         'icon'      : 'assets/icons/invoice.png',
    //                                         'route'     : './services/asset-assignment-list'
    //                                     },  
    //                                     { 
    //                                       'id'        : 'services-bo-assetShipment' ,
    //                                       'label'     : 'Expédition Client',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : './services/asset-shipment-list'
    //                                   }, 
    //                                   {
    //                                       'id'        : 'services-bo-ticket'  ,
    //                                       'label'     : 'Tickets',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : './services/asset-ticket'
    //                                   },
    //                                   {
    //                                       'id'        : 'services-bo-ticketBatch'  ,
    //                                       'label'     : 'Lot de Tickets',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : './services/asset-ticketBtach'
    //                                   },
    //                                   {
    //                                     'id'        : 'services-bo-ticket-xtrn'  ,
    //                                     'label'     : 'Tickets A Importer',
    //                                     'icon'      : 'assets/icons/invoice.png',
    //                                     'route'     : './services/asset-ticket-xtrn'
    //                                   },
    //                                   {
    //                                       'id'        : 'services-bo-assetInventory'  ,
    //                                       'label'     : 'Inventaires',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : './services/asset-inventory'
    //                                   }, 
    //                                   {
    //                                       'id'        : 'services-bo-assetReports'  ,
    //                                       'label'     : 'Rapports',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : ''
    //                                   }
    //                                  ]
    //                   },
    //                   {
    //                   'id'         : 'services-master-data',
    //                   'title'      : 'Administration',
    //                   'icon'       :  'assets/images/icons/settings.png',
    //                   'items'      : [
    //                                     {
    //                                       'id'        : 'asset-product-category-list',
    //                                       'label'     : 'Catégories de frigos',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : './services/asset-product-category-list'
    //                                   }, 
    //                                   {
    //                                       'id'        : 'asset-product-list',
    //                                       'label'     : 'Références de Frigos',
    //                                       'icon'      : 'assets/icons/invoice.png',
    //                                       'route'     : './services/asset-product-list'
    //                                   }, 
    //                                  ]
    //                   }
    //               ]
  // }

  
  constructor(
    protected router              : Router,
    protected configService       : ConfigService,
    protected activatedRoute      : ActivatedRoute,
  ) { 
    super(router, activatedRoute);
  }


  select(itemId : string){
      if (itemId == 'asset-reports') {
        this.openReports();
      }
  }
  openReports(){
    let url= this.configService.config.reportsAppUrl;
    window.open(url)
  }

}
